// extracted by mini-css-extract-plugin
export var content = "product-description-module--content--8f62e";
export var descriptionTitle = "product-description-module--description-title--b2dda";
export var displayContent = "product-description-module--display-content--d2d94";
export var productDiscription = "product-description-module--product-discription--dffc9";
export var productIcon = "product-description-module--product-icon--e2f52";